import { put, call, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { axiosInstance, apiURL } from 'config';
import {
  loadProductsRequested,
  loadProductsSuccess,
  loadProductsFail,
  storeProductRequested,
  storeProductSuccess,
  storeProductFail,
  storeProductImageRequested,
  storeProductImageSuccess,
  storeProductImageFail,
  deleteProductSuccess,
  deleteProductFail,
  deleteProductRequested,
  loadProductsBySubCategoriesSuccess,
  loadProductsBySubCategoriesFail,
  loadProductsBySubCategoriesRequested,
  updateProductSuccess,
  updateProductFail,
  updateProductRequested,
  loadProductRequested,
  loadProductFail,
  loadProductSuccess,
  loadNonPaginatedProductRequested,
  loadNonPaginatedProductFail,
  loadNonPaginatedProductSuccess,
  stockStatusChangeFail,
  stockStatusChangeRequested,
  stockStatusChangeSuccess,
  updatePriceFail,
  updatePriceRequested,
  updatePriceSuccess,
} from './productsSlice';

//load products
export function* loadProductsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-item-index?page=${action?.payload?.page}&pageSize=${
        action?.payload?.perPage
      }&searchString=${action?.payload?.filters?.query ?? ''}${
        action?.payload?.filters?.category?.id
          ? '&categoryId=' + action?.payload?.filters?.category?.id
          : ''
      }`
    );
    yield put(loadProductsSuccess(data));
  } catch (error: any) {
    yield put(loadProductsFail(error.message));
  }
}

export function* loadProductEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-item-by-id?Id=${action.payload}`,
      action.payload
    );
    yield put(loadProductSuccess(data));
  } catch (error: any) {
    yield put(loadProductFail(error.message));
  }
}

export function* storeProductEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-item`,
      action.payload?.values
    );
    if (data?.result) {
      yield put(storeProductSuccess(data));
      if (action?.payload?.values?.image) {
        const image: File = action?.payload?.values?.image;
        const formData = new FormData();
        formData.append('Image', image);

        yield call(storeProductImageEffect, {
          payload: {
            id: data?.result,
            content: formData,
          },
          type: '',
        });
      }

      toast.success('product created successfully');
      action.payload?.navigate('/products');
    } else {
      toast.error('Product create failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeProductFail(error.message));
  }
}

export function* updateProductEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/edit-item`,
      action?.payload?.values
    );
    if (data?.succeeded) {
      yield put(updateProductSuccess(data));
      if (action?.payload?.values?.image) {
        const image = action?.payload?.values?.image;

        if (image instanceof Blob || image instanceof File) {
          const formData = new FormData();

          formData.append('Image', image);

          yield call(storeProductImageEffect, {
            payload: {
              id: action?.payload?.values?.id,
              content: formData,
            },
            type: '',
          });
        }
      }

      toast.success('Product edited successfully');
      action.payload?.navigate('/products');
    }
  } catch (error: any) {
    yield put(updateProductFail(error.message));
  }
}

export function* updatePriceEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/update-c&d-price-by-item-id`,
      action?.payload
    );
    if (data?.succeeded) {
      yield put(updatePriceSuccess(data));
      yield call(loadProductsEffect, {
        payload: {
          page: action?.payload?.page,
          perPage: action?.payload?.perPage,
          filters: {
            category: {
              id: action?.payload?.filter,
            },
          },
        },
        type: '',
      });
      toast.success('Price updated successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updatePriceFail(error.message));
  }
}

export function* storeProductImageEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/set-image-item?Id=${action.payload.id}`,
      action.payload?.content,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    if (data?.succeeded) {
      yield put(storeProductImageSuccess(data));
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(storeProductImageFail(error.message));
  }
}

export function* deleteProductEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-item-soft?Id=${action.payload.item.id}`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(deleteProductSuccess(data));
      toast.success('Product deleted successfully');
    }
  } catch (error: any) {
    yield put(deleteProductFail(error.message));
  }
}

//load products by sub categories
export function* loadProductsBySubCategoriesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,

      `${apiURL}/get-items-by-subcategory-ids`,
      action.payload
    );
    yield put(loadProductsBySubCategoriesSuccess(data));
  } catch (error: any) {
    yield put(loadProductsBySubCategoriesFail(error.message));
  }
}

export function* loadNonPaginatedProductEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-item-index`,
      action.payload
    );
    yield put(loadNonPaginatedProductSuccess(data));
  } catch (error: any) {
    yield put(loadNonPaginatedProductFail(error.message));
  }
}

export function* stockStatusChangeEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/stock-status-change?Id=${action.payload?.itemId}`
    );
    if (data?.succeeded) {
      
      yield put(stockStatusChangeSuccess(data));
      yield call(loadProductsEffect, {
        payload: {
          page: action?.payload?.page,
          perPage: action?.payload?.perPage,
          filters: {
            category: {
              id:  action?.payload?.filter,
            },
          },
        },
        type: '',
      });
      toast.success('Availability updated successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(stockStatusChangeFail(error.message));
  }
}

export function* productSaga(): Generator<any, void, any> {
  yield takeEvery(loadProductsRequested, loadProductsEffect);
  yield takeEvery(loadProductRequested, loadProductEffect);
  yield takeEvery(storeProductRequested, storeProductEffect);
  yield takeEvery(updateProductRequested, updateProductEffect);
  yield takeEvery(deleteProductRequested, deleteProductEffect);
  yield takeEvery(storeProductImageRequested, storeProductImageEffect);
  yield takeEvery(
    loadProductsBySubCategoriesRequested,
    loadProductsBySubCategoriesEffect
  );
  yield takeEvery(
    loadNonPaginatedProductRequested,
    loadNonPaginatedProductEffect
  );
  yield takeEvery(stockStatusChangeRequested, stockStatusChangeEffect);
  yield takeEvery(updatePriceRequested, updatePriceEffect);
}
